export const CLIENT_ID =
  process.env.NEXT_PUBLIC_ZAPIER_OAUTH_APP_ID ||
  // Production client ID
  "DH6yfoy5OrDnhZ20JngUPvL2nBwESF7tOVXRSon9";

export const ZAPIER_ORIGIN =
  process.env.NEXT_PUBLIC_ZAPIER_ORIGIN || "https://zapier.com";

export const ZAPIER_API_ORIGIN =
  process.env.NEXT_PUBLIC_ZAPIER_API_ORIGIN || "https://api.zapier.com";

export const ELEMENTS_BASE_URL =
  process.env.NEXT_PUBLIC_ZAPIER_ELEMENTS_BASE_URL ||
  "https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js";

export const ELEMENTS_IS_PRODUCTION = ELEMENTS_BASE_URL.startsWith(
  "https://cdn.zapier.com"
);

export const GTM_ID =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "staging"
    ? "GTM-PD8S23G"
    : "GTM-K7GFJTV";

export const ZAPIER_API_SCOPES = [
  "authentication",
  "authentication:write",
  "profile",
  "templates",
  "zap",
  "zap:write",
].join(" ");
